export default {"src":"/_next/static/image/public/images/ic_incomplete_doc.a813ff3d482bc5ea26dc183a02c184aa.svg","height":70,"width":70};